import { normalizeAllowedActions } from '../permissions/normalize'

type OperationLike = {
  allowed_actions?: unknown
  status?: string | null
}

const normalizeStatus = (status?: string | null) => String(status || '').trim().toLowerCase()

export const isOperationInProgress = (operation?: OperationLike | null) =>
  normalizeStatus(operation?.status) === 'in progress'

export const isOperationSucceeded = (operation?: OperationLike | null) =>
  normalizeStatus(operation?.status) === 'succeeded'

export const canRetryOperation = (operation?: OperationLike | null) => {
  if (!operation || isOperationInProgress(operation) || isOperationSucceeded(operation)) {
    return false
  }

  return true
}

export const getOperationAllowedActions = (operation?: OperationLike | null) => {
  const actions = new Set(normalizeAllowedActions(operation?.allowed_actions))

  if (isOperationInProgress(operation)) {
    actions.add('abort_operation')
  } else {
    actions.delete('abort')
    actions.delete('abort_operation')
  }

  if (canRetryOperation(operation)) {
    actions.add('retry')
  } else {
    actions.delete('retry')
    actions.delete('rerun')
  }

  return Array.from(actions)
}
